import React, { useState, useEffect, useMemo } from 'react';
import { object, func } from 'prop-types';
import { TableCustom, Loading, Modal } from '../../common';
import { ALERT_TYPE, REQUEST_METHOD, ShowToastMessage, TRIBUTO_TYPE } from '@laramie/ui';
import { ServerRequest } from '../../../utils/apiweb';
import { APIS } from '../../../config/apis';
import { getDateToString, getFormatNumber, precisionRound } from '../../../utils/convert';
import { useEntidad } from '../../hooks';
import CuentaCorrienteCondicionesEspecialesGrid from '../CuentaCorrienteCondicionesEspecialesGrid';
import CuentaCorrienteItemModal from '../CuentaCorrienteItemModal';
import { isNull } from '../../../utils/validator';
import {usePermissions} from "../../hooks/usePermissions";
import {PERMISSIONS} from "../../../consts/permissions";
import CuentaDebitoCreditoModal from '../CuentaDebitoCreditoModal';

const CuentaDebitoCreditoPartidaGrid = (props) => {

    //hooks
    const [state, setState] = useState({
        list: [],
        loading: false,
        showForm: false,
        rowId: 0,
        showFormDebitoCredito: false,
        rowForm: null
    });
    const [idTipoTributo, setIdTipoTributo] = useState(0);
    const [items, setItems] = useState([]);
    const [hasCondicionesEspeciales, setHasCondicionesEspeciales] = useState([]);
    const [dataCondicionEspecial, setDataCondicionEspecial] = useState({
        id: 0,
        idCuenta: 0,
        numeroPartida: 0,
        codigoDelegacion: '',
        numeroMovimiento: 0,
        showForm: false
    });
    const [hasChanges, setHasChanges] = useState(false);

    const mount = () => {
        if(props.data?.numeroPartida > 0) {
            setIdTipoTributo(props.data.idTipoTributo);
            SearchCondicionesEspeciales(props.data.idCuenta);
        }
    }
    useEffect(mount, [props.data.numeroPartida]);

    const [, getRowEntidad] = useEntidad({
        entidades: ['Tasa','SubTasa','Rubro','TipoMovimiento'],
        onLoaded: (entidades, isSuccess, error) => {
          if (isSuccess) {
            setState(prevState => ({...prevState}));
          }
          else {
            ShowToastMessage(ALERT_TYPE.ALERT_ERROR, error);
          }
        },
        memo: {
            key: 'Tasa_SubTasa_Rubro_TipoMovimiento',
            timeout: 0
        }
    });

    const { hasPermission } = usePermissions();
    const canEditDebitoCredito = hasPermission(PERMISSIONS.DEBITO_CREDITO_EDIT);


    //definiciones
    const cellA = (data) =>    <div className='action'>
                                {canEditDebitoCredito && (
                                    <div onClick={ (event) => handleClickItemAdd() } className="link">
                                       <span className="material-symbols-outlined" title="Nuevo">add</span>
                                    </div>
                                )}
                              </div>
    const cellVMR = (props) =>  <div className='action'>
                                    <div onClick={ (event) => handleClickItemView(props.value) } className="link">
                                        <span className="material-symbols-outlined" title="Ver">search</span>
                                    </div>
                                    {hasCondicionesEspeciales &&
                                    <div onClick={ (event) => handleClickItemViewCondicionEspecial(props.value) } className="link">
                                        <span className="material-symbols-outlined" title="Ver condiciones especiales">warning</span>
                                    </div>
                                    }
                                </div>

    const getDescTipoMovimiento = (id) => {
        const row = getRowEntidad('TipoMovimiento', id);
        return (row) ? row.nombre : '';
    }
    const getCodigoTasa = (id) => {
        const row = getRowEntidad('Tasa', id);
        return (row) ? row.codigo : '';
    }
    const getDescSubTasa = (id) => {
        const row = getRowEntidad('SubTasa', id);
        return (row) ? `${row.codigo} - ${row.descripcion}` : '';
    }
    const getCodigoRubro = (id) => {
        const row = getRowEntidad('Rubro', id);
        return (row) ? row.codigo : '';
    }
    const GetFooterTotal = (info, columnName) => {
        const total = useMemo(
            () =>
            info.rows.reduce((sum, row) => row.values[columnName] + sum, 0),
            [info.rows]
        )

        return <>{getFormatNumber(total,2)}</>
    }

    const columnRubro = useMemo(() =>
        (idTipoTributo === TRIBUTO_TYPE.COMERCIOS) ? [
            { Header: 'Rubro', accessor: 'codigoRubro', width: '5%', disableSortBy: true, ellipsis: false}
        ] : []
    , [idTipoTributo])

    const tableColumns = [
        { Header: 'Código', accessor: 'operacion', width: '4%', alignCell: 'right', disableSortBy: true, ellipsis: false},
        { Header: 'Tasa', accessor: 'codigoTasa', width: '5%', disableSortBy: true, ellipsis: false},
        { Header: 'Sub tasa', accessor: 'descSubTasa', width: '19%', disableSortBy: true},
        { Header: 'Periodo', Cell: ({row}) => `${row.original.periodo}/${row.original.cuota}`, accessor: 'periodo', width: '6%', alignCell: 'right', disableSortBy: true, ellipsis: false},
        ...columnRubro,
        { Header: 'Fecha', Cell: (props) => (props.value) ? getDateToString(props.value, false) : '', accessor: 'fechaMovimiento', width: '7%', disableSortBy: true, ellipsis: false},
        { Header: 'Movimiento', Cell: (props) => getDescTipoMovimiento(props.value), accessor: 'idTipoMovimiento', width: '10%', disableSortBy: true},
        // { Header: 'Número', accessor: 'codigoMovimiento', alignCell: 'right', width: '13%', disableSortBy: true, ellipsis: false},
        { Header: 'Debe', Footer: (info) => GetFooterTotal(info ,'importeDebe'), Cell: (props) => getFormatNumber(props.value, 2), id: 'importeDebe', accessor: 'importeDebe', width: '7%', alignCell: 'right', disableSortBy: true, ellipsis: false},
        { Header: 'Haber', Footer: (info) => GetFooterTotal(info ,'importeHaber'), Cell: (props) => getFormatNumber(props.value, 2), id: 'importeHaber', accessor: 'importeHaber', width: '7%', alignCell: 'right', disableSortBy: true, ellipsis: false},
        { Header: 'Saldo', Cell: (props) => getFormatNumber(props.value, 2), accessor: 'importeSaldo', width: '7%', alignCell: 'right', disableSortBy: true, ellipsis: false},
        { Header: 'Vto.', Cell: (props) => getDateToString(props.value), accessor: 'fechaVencimiento2', width: '7%', alignCell: 'right', disableSortBy: true, ellipsis: false},
        { Header: cellA, Cell: cellVMR, id:'abm', accessor: 'id', width: '5%', disableGlobalFilter: true, disableSortBy: true, ellipsis: false}
    ];

    const sortCuentaCorriente = (a,b) => (b.cuota === a.cuota) ?  b.item - a.item : b.cuota - a.cuota;

    //handles
    const handleClickItemAdd = () => {
        const rowTasaCabecera = items.find(f => f.tasaCabecera);
        if (!rowTasaCabecera) {
            ShowToastMessage(ALERT_TYPE.ALERT_WARNING, "No hay una tasa cabecera definida");
            return;
        }
        setState(prevState => {
            return {...prevState, showFormDebitoCredito: true, rowForm: rowTasaCabecera};
        });
    }
    const handleClickItemView = (id) => {
        setState(prevState => {
            return {...prevState, showForm: true, rowId: parseInt(id)};
        });
    }
    const handleClickItemViewCondicionEspecial = (id) => {
        const item = items.find(x => x.id === id);
        const dataCondicionEspecial = {
            idCuenta: item.idCuenta,
            numeroPartida: item.numeroPartida,
            codigoDelegacion: item.codigoDelegacion,
            numeroMovimiento: item.numeroMovimiento,
            showForm: true
        };
        setDataCondicionEspecial(dataCondicionEspecial);
    }

    //callbacks
    const callbackNoSuccess = (response) => {
        response.json()
        .then((error) => {
            const message = error.message;
            ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
            setState(prevState => {
                return {...prevState, loading: false};
            });
        })
        .catch((error) => {
            const message = 'Error procesando respuesta: ' + error;
            ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
            setState(prevState => {
                return {...prevState, loading: false};
            });
        });
    }
    const callbackError = (error) => {
        const message = 'Error procesando solicitud: ' + error.message;
        ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
        setState(prevState => {
            return {...prevState, loading: false};
        });
    }
    const callbackSuccessSearchCondicionesEspeciales = (response) => {
        response.json()
        .then((data) => {

            if (props.data.numeroPartida > 0) {
                setHasCondicionesEspeciales(data.some(f => f.numeroPartida === props.data.numeroPartida));
            }
            else {
                setHasCondicionesEspeciales(false);
            }
            SearchCuentaCorrienteItem(props.data.numeroPartida);
        })
        .catch((error) => {
            const message = 'Error procesando respuesta: ' + error;
            ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
            setState(prevState => {
                return {...prevState, loading: false};
            });
        });
    }
    const callbackSuccessSearchCuentaCorrienteItem = (response) => {
        response.json()
        .then((items) => {

            let importeSaldoAnterior = 0;
            items.sort(sortCuentaCorriente);
            for (let index=items.length-1; index>=0; index--) {
                let item = items[index];
                if (item.fechaMovimiento) item.fechaMovimiento = new Date(item.fechaMovimiento);
                if (item.fechaOrigen) item.fechaOrigen = new Date(item.fechaOrigen);
                if (item.fechaVencimiento1) item.fechaVencimiento1 = new Date(item.fechaVencimiento1);
                if (item.fechaVencimiento2) item.fechaVencimiento2 = new Date(item.fechaVencimiento2);
                if (item.fechaVencimiento1Original) item.fechaVencimiento1Original = new Date(item.fechaVencimiento1Original);
                if (item.fechaVencimiento2Original) item.fechaVencimiento2Original = new Date(item.fechaVencimiento2Original);
                if (item.fechaVencimiento1Prorroga) item.fechaVencimiento1Prorroga = new Date(item.fechaVencimiento1Prorroga);
                if (item.fechaVencimiento2Prorroga) item.fechaVencimiento2Prorroga = new Date(item.fechaVencimiento2Prorroga);
                if (item.fechaRegistro) item.fechaRegistro = new Date(item.fechaRegistro);
                if (item.fechaProceso) item.fechaProceso = new Date(item.fechaProceso);
                if (item.fechaCobro) item.fechaCobro = new Date(item.fechaCobro);

                item.codigoTasa = getCodigoTasa(item.idTasa);
                item.descSubTasa = getDescSubTasa(item.idSubTasa);
                item.codigoRubro = !isNull(item.idRubro) ? getCodigoRubro(item.idRubro) : '';

                importeSaldoAnterior = precisionRound(importeSaldoAnterior + item.importeDebe - item.importeHaber);
                item.index = index;
                item.selected = false;
                item.importeSaldo = 0;
                item.importeSaldoFiltro = 0;
                item.importeSaldoAnterior = importeSaldoAnterior;
                item.codigoMovimiento = `${item.codigoDelegacion}-${item.numeroMovimiento}-${item.item}`
                item.operacion = item.id;
            }

            setState(prevState => {
                return {...prevState, loading: false, list: items};
            });
            FilterCuentaCorrienteItem(items);
        })
        .catch((error) => {
            const message = 'Error procesando respuesta: ' + error;
            ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
            setState(prevState => {
                return {...prevState, loading: false};
            });
        });
    }

    // funciones
    function SearchCondicionesEspeciales(idCuenta) {

        setState(prevState => {
            return {...prevState, loading: true};
        });

        const paramsUrl =  `/cuenta/${idCuenta}`;

        ServerRequest(
            REQUEST_METHOD.GET,
            null,
            true,
            APIS.URLS.CUENTA_CORRIENTE_CONDICION_ESPECIAL,
            paramsUrl,
            null,
            callbackSuccessSearchCondicionesEspeciales,
            callbackNoSuccess,
            callbackError
        );

    }
    function SearchCuentaCorrienteItem(numeroPartida) {

        const paramsUrl = `/partida/${numeroPartida}`;

        ServerRequest(
            REQUEST_METHOD.GET,
            null,
            true,
            APIS.URLS.CUENTA_CORRIENTE_ITEM,
            paramsUrl,
            null,
            callbackSuccessSearchCuentaCorrienteItem,
            callbackNoSuccess,
            callbackError
        );
    }
    function FilterCuentaCorrienteItem(fullItems) {
        let items = [...fullItems];

        let importeSaldoFiltro = 0;
        items.sort(sortCuentaCorriente);
        for (let index=items.length-1; index>=0; index--) {
            let item = items[index];
            importeSaldoFiltro = precisionRound(importeSaldoFiltro + item.importeDebe -item.importeHaber);
            item.index = index;
            item.importeSaldoFiltro = importeSaldoFiltro;
            item.importeSaldo = item.importeSaldoFiltro;
        }

        setItems(items);
    }

    return (
    <>
        <Loading visible={state.loading}></Loading>

        <Modal
            onEscape={() => props.onDismiss(hasChanges)}
            size="xl"
            allowFullscreen={true}
            title={"Débitos y créditos - Partida " + (props.data?.numeroPartida > 0 ? props.data?.numeroPartida : '')}
            body={<>
                {state.showFormDebitoCredito && 
                    <CuentaDebitoCreditoModal
                        data={{
                            entity: state.rowForm,
                            tasas: items.map(x => {
                                return {
                                    idTasa: x.idTasa,
                                    idSubTasa: x.idSubTasa
                                }
                            }),
                            rubros: items.map(x => x.idRubro??0)
                        }}
                        onDismiss={() => {
                            setState(prevState => {
                                return {...prevState, showFormDebitoCredito: false, rowForm: null};
                            });
                        }}
                        onConfirm={(row) => {
                            setState(prevState => {
                                return {...prevState, showFormDebitoCredito: false, rowForm: null};
                            });
                            setHasChanges(true);
                            SearchCuentaCorrienteItem(props.data.numeroPartida);
                        }}
                    />
                }
                {state.showForm && 
                    <CuentaCorrienteItemModal
                        data={{
                            idTipoTributo: idTipoTributo,
                            idCuentaCorrienteItem: state.rowId
                        }}
                        onDismiss={() => {
                            setState(prevState => {
                                return {...prevState, showForm: false, rowId: 0};
                            });
                        }}
                    />
                }
                {dataCondicionEspecial.showForm && 
                    <CuentaCorrienteCondicionesEspecialesGrid
                        data={{
                            idCuenta: dataCondicionEspecial.idCuenta,
                            idTipoTributo: idTipoTributo,
                            numeroPartida: dataCondicionEspecial.numeroPartida,
                            codigoDelegacion: dataCondicionEspecial.codigoDelegacion,
                            numeroMovimiento: dataCondicionEspecial.numeroMovimiento
                        }}
                        onDismiss={() => {
                            setDataCondicionEspecial(prevState => { return {...prevState, showForm: false}; });
                        }}
                        disabled={true}
                    />
                }
                <TableCustom
                    className={'TableCustomBase'}
                    columns={tableColumns}
                    data={ items }
                    showFooter={true}
                    showFilterGlobal={false}
                />
            </>}
            footer={<div className="width-100p f-align">
                <button className="btn back-button" data-dismiss="modal" onClick={ (event) => props.onDismiss(hasChanges) }>Volver</button>
            </div>}
        />

    </>
    );
}

CuentaDebitoCreditoPartidaGrid.propTypes = {
    data: object.isRequired,
    onDismiss: func.isRequired
  };

export default CuentaDebitoCreditoPartidaGrid;